static {}
$ var cancelId = component.getElId("confirm-dialog-cancel");
$ var confirmId = component.getElId("confirm-dialog-confirm");
$ var mainId = component.getElId("confirm-dialog-main");
static var validConfirmCTAVariants = ["destructive"];
$ const {
  confirmCtaVariant,
  rejectText,
  confirmText,
  class: inputClass,
  reject,
  confirm,
  renderBody,
  ...dialogInput
} = input;
$ const {
  renderBody: confirmRenderBody,
  ...confirmRestOfInput
} = confirm || {};
$ const {
  renderBody: rejectRenderBody,
  ...rejectRestOfInput
} = reject || {};
<ebay-dialog-base ...dialogInput on-open("emit", "open") on-close("emit", "close") on-escape("emit", "reject") main-id=mainId focus=confirmId transition-list=["opacity", "transform", "background-color"] class-prefix="confirm-dialog" class=[inputClass, "confirm-dialog--mask-fade"] window-class=["confirm-dialog__window--animate"] button-position="hidden">
  <@footer>
    <ebay-button on-click("emit", "reject") id=cancelId class="confirm-dialog__reject" ...rejectRestOfInput>
      <if(rejectText)>
        ${rejectText}
      </if>
      <else>
        <${rejectRenderBody}/>
      </else>
    </ebay-button>
    <ebay-button priority="primary" on-click("emit", "confirm") id=confirmId aria-describedby=mainId class=["confirm-dialog__confirm", confirmCtaVariant && validConfirmCTAVariants.includes(confirmCtaVariant) && `btn--${confirmCtaVariant}`] ...confirmRestOfInput>
      <if(confirmText)>
        ${confirmText}
      </if>
      <else>
        <${confirmRenderBody}/>
      </else>
    </ebay-button>
  </@footer>
  <${renderBody}/>
</ebay-dialog-base>